import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'radio-button-usage',
  templateUrl: './radio-button-usage.component.html',
  styleUrls: ['./radio-button-usage.component.sass']
})
export class RadioButtonUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
